export default {
  header: 'Vrijgaven',
  empty: 'Geen vrijgaven in deze periode.',
  date: 'Datum',
  product: 'Product',
  bottleSize: 'Fles-/blikgrootte',
  amount: 'Aantal',
  batch: 'Batch',
  note: 'Opmerking',
  excise: 'Te betalen accijns (€)',
  exciseStatus: 'Accijnsstatus',
  paidOn: 'Betaald op',
  paymentRef: 'Betalingsreferentie',
  paid: 'Betaald',
  unpaid: 'Onbetaald',
};
